import {
  PageContainer,
  SmallPaddingCard,
  SignTitle,
  IconFont,
  DeleteModal,
  SvgIcon,
  TableTag,
} from '@/components'
import styled from 'styled-components'
import { Scrollbars } from 'react-custom-scrollbars'
import {
  Button,
  Card,
  Checkbox,
  Collapse,
  Dropdown,
  Empty,
  Form,
  Input,
  Menu,
  Modal,
  Space,
  Tooltip,
  Typography,
} from 'antd'
const { Panel } = Collapse
import { List } from './list'
import { useEffect, useMemo, useState, useCallback, useRef } from 'react'
import { FixedSizeList } from 'react-window'
import Overview from '@/assets/imges/phishing/create/overview_line1.png'
import {
  useAddGroup,
  useDeleteGroup,
  useEditGroup,
  useGetGroupAll,
  useGetTagList,
  useGetTask,
} from './utils'
import { useDebounceFn, useEventEmitter, useSelections } from 'ahooks'
import { SearchInputTwo } from '@/components/search-input-two'
import { BatchAdd } from './batch-add'
import ReactECharts from 'echarts-for-react'
import { TaskName } from './task-name'
import { LabelManagement } from './label-management'
import { useNavigate } from 'react-router'
import CompanyScore from './company'
import EmptyImg from '@/assets/imges/Empty/Empty.png'
import { t } from '@/i18n'
const { useForm } = Form

interface DelteModal {
  visibel: boolean
  deleteid: string[] | null
}
export interface Group {
  name?: string
  id: string
  update_time?: string
}
export interface IItemDetail {
  id: string | null
  name: string
}
interface IModalDetail {
  addVisible?: boolean
  editVisible?: boolean
  deleteVisible?: boolean
  labelVisible?: boolean
  id?: string
  ids?: string[]
}
const defaultModalDetail: IModalDetail = {
  addVisible: false,
  editVisible: false,
  deleteVisible: false,
  labelVisible: false,
}
const User = () => {
  // 触发获取邮件列表事件总线
  const getEmailList$ = useEventEmitter()
  const [getTaskList, taskList] = useGetTask()
  const [deleteGroup] = useDeleteGroup()
  const [editGroup] = useEditGroup()
  const [selectGroup, setSelectGroup] = useState<Group | undefined>()

  const [searchGroup, setSearchGroup] = useState<string>()
  const [groupList, getGroupList] = useGetGroupAll()
  const { run: searchTask } = useDebounceFn(
    (name: string) => {
      getGroupList({ name: name })
        .then(res => {})
        .catch(res => {})
    },
    {
      wait: 300,
    },
  )
  // useEffect(() => {
  //   if (groupList?.length > 0) {
  //     setSelectGroup({
  //       id: null,
  //       name: groupList[0]?.name,
  //     })
  //   }
  // }, [groupList])

  const list = useMemo(() => {
    let arr = groupList.slice(1)
    return arr
  }, [groupList])
  const [getTagList, TagListData] = useGetTagList()
  const [isModalVisible, setIsModalVisible] = useState(false)
  const [current, setCurrent] = useState<IItemDetail>()
  let [modalDetail, setModalDetail] = useState<IModalDetail>(defaultModalDetail)

  const groupListIds = useMemo(() => {
    let arr = []
    groupList?.map(item => {
      if (item.id !== '') {
        arr.push(item.id)
      }
    })
    return arr
  }, [groupList])
  const { selected, allSelected, isSelected, setSelected, toggle, toggleAll, partiallySelected } =
    useSelections<string>(groupListIds, [])
  const [addForm] = useForm()
  const [editForm] = useForm()
  const [addGroup] = useAddGroup()
  const isModalVisibleClose = (data: boolean) => {
    if (data) {
      getTagList()
    }
    setIsModalVisible(false)
  }
  const [upLoadGroupModal, setUpLoadGroupModal] = useState(false)
  const [listHeight, setListHeight] = useState(600)
  const listContainerRef = useRef<HTMLDivElement>(null)

  const visible = () => {
    setUpLoadGroupModal(true)
  }
  const cancel = () => {
    setUpLoadGroupModal(false)
  }
  // 计算列表高度
  useEffect(() => {
    const updateListHeight = () => {
      if (listContainerRef.current) {
        const container = listContainerRef.current
        const containerHeight = container.clientHeight
        // 减去公司名称区域高度(72px)和其他边距(12px)
        const calculatedHeight = containerHeight - 84
        if (calculatedHeight > 0) {
          setListHeight(calculatedHeight)
        }
      }
    }
    // 延迟执行以确保 DOM 已渲染
    const timer = setTimeout(updateListHeight, 100)
    window.addEventListener('resize', updateListHeight)
    return () => {
      clearTimeout(timer)
      window.removeEventListener('resize', updateListHeight)
    }
  }, [groupList])

  const option = (props: { value: number; title: string }) => {
    const { value, title } = props
    return {
      series: [
        {
          type: 'gauge',
          min: 0,
          max: 100,
          splitNumber: 5,
          radius: '100%',
          axisLine: {
            lineStyle: {
              width: 10,
              color: [
                [0.39, '#FF5151'],
                [0.59, '#FFB035'],
                [0.79, '#739DFF'],
                [1, '#7FB663'],
              ],
            },
          },
          pointer: {
            icon: 'path://M12.8,0.7l12,40.1H0.7L12.8,0.7z',
            length: '15%',
            width: 10,
            offsetCenter: [0, -30],
            itemStyle: {
              color: 'auto',
            },
          },
          axisTick: {
            length: 5,
            lineStyle: {
              color: 'auto',
              width: 1,
            },
            distance: 3,
          },
          splitLine: {
            length: 7,
            distance: 2,
            lineStyle: {
              color: 'auto',
              width: 2,
            },
          },
          axisLabel: {
            color: '#666666',
            fontSize: 8,
            distance: 15,
          },
          title: {
            offsetCenter: [0, 20],
            fontSize: 13,
            color: 'auto',
          },
          detail: {
            fontSize: 26,
            offsetCenter: [0, '-5%'],
            valueAnimation: true,
            formatter: function (num) {
              return `${Math.round(num)}`
            },
            color: 'auto',
          },
          data: [
            {
              value: value || 0,
              name: title,
            },
          ],
        },
      ],
    }
  }
  const [recently, setRecently] = useState([1])

  const handleDeleteGroup = async () => {
    try {
      await deleteGroup({ ids: modalDetail.ids })
      getGroupList({})
      setSelected([])
      setModalDetail(defaultModalDetail)
    } catch (error) {}
  }

  const handleBatchAdd = () => {
    getGroupList({})
  }

  useEffect(() => {
    setCurrent({
      id: null,
      name: groupList[0]?.name,
    })
  }, [])

  const handleAddGroup = async (values: { name: string }) => {
    const { name } = values
    try {
      await addGroup({ name })
      getGroupList({})
      addForm.resetFields()
      setModalDetail(defaultModalDetail)
    } catch (error) {}
  }

  const handleEditGroup = async (values: { name: string }) => {
    const { name } = values
    try {
      await editGroup({
        name,
        id: modalDetail.id,
      })
      getGroupList({})
      editForm.resetFields()
      setModalDetail(defaultModalDetail)
    } catch (error) {}
  }

  const navigate = useNavigate()

  // 虚拟列表项渲染函数
  const renderVirtualListItem = useCallback(
    ({ index, style }: { index: number; style: React.CSSProperties }) => {
      const item = list[index]
      if (!item) return null

      const { id, name, task_level, task_end_time } = item
      const menu = (
        <Menu
          className="group-menu"
          items={[
            {
              key: '1',
              label: (
                <div
                  className="group-menu-item"
                  onClick={e => {
                    e.stopPropagation()
                    navigate('/validation/awareness/phishing?tab=create', {
                      state: { group_id: id },
                    })
                  }}
                >
                  {t('创建任务')}
                </div>
              ),
              icon: (
                <SvgIcon
                  name={'创建任务'}
                  style={{ width: '16px', height: '16px', marginLeft: 14 }}
                />
              ),
            },
            {
              key: '2',
              label: (
                <div
                  className="group-menu-item"
                  onClick={e => {
                    e.stopPropagation()
                    if (name === '未分配部门') return
                    setModalDetail((modalDetail = { editVisible: true, id: id }))
                    editForm.setFieldValue('name', name)
                  }}
                >
                  {t('编辑')}
                </div>
              ),
              icon: <IconFont type="icon-bianji" style={{ fontSize: '16px', marginLeft: 14 }} />,
              disabled: name === '未分配部门',
            },
            {
              key: '3',
              label: (
                <div
                  className="group-menu-item"
                  onClick={e => {
                    e.stopPropagation()
                    if (name === '未分配部门') return
                    setModalDetail((modalDetail = { deleteVisible: true, ids: [id] }))
                  }}
                >
                  {t('删除')}
                </div>
              ),
              icon: <IconFont type="icon-shanchu-m" style={{ fontSize: '16px', marginLeft: 14 }} />,
              disabled: name === '未分配部门',
            },
          ]}
        />
      )

      return (
        <div style={style}>
          <GroupItem
            key={id}
            isActive={id === current?.id}
            onClick={async () => {
              try {
                await getTaskList({ group_id: id })
                setSelectGroup({
                  id: id,
                  name: name,
                  update_time: task_end_time,
                })
              } catch (error) {}
              setCurrent({
                id: id,
                name: name,
              })
            }}
          >
            <div className="detail">
              <div className="header">
                <Checkbox
                  checked={isSelected(id) && name !== '未分配部门'}
                  disabled={name === '未分配部门'}
                  onClick={e => {
                    e.stopPropagation()
                    toggle(id)
                  }}
                >
                  {task_end_time ? (
                    task_level ? (
                      <div>
                        {task_level === '优秀' && (
                          <TableTag
                            background="#D6F4C7"
                            color="#5BC825"
                            style={{ marginLeft: 8, padding: '2px 6px' }}
                          >
                            {task_level}
                          </TableTag>
                        )}
                        {task_level === '良好' && (
                          <TableTag
                            background="#E2E4FF"
                            color="#2973FF"
                            style={{ marginLeft: 8, padding: '2px 6px' }}
                          >
                            {task_level}
                          </TableTag>
                        )}
                        {task_level === '较差' && (
                          <TableTag
                            background="#FFEBB4"
                            color="#FFA709"
                            style={{ marginLeft: 8, padding: '2px 6px' }}
                          >
                            {task_level}
                          </TableTag>
                        )}
                        {task_level === '差' && (
                          <TableTag
                            background="#FFC9C9"
                            color="#FF2929"
                            style={{ marginLeft: 8, padding: '2px 6px' }}
                          >
                            {task_level}
                          </TableTag>
                        )}
                      </div>
                    ) : null
                  ) : (
                    <div>
                      {(() => {
                        switch (task_level) {
                          case '优秀':
                            return (
                              <TableTag
                                background="#D6F4C7"
                                color="#5BC825"
                                style={{ marginLeft: 8, padding: '2px 6px' }}
                              >
                                {task_level}
                              </TableTag>
                            )

                          case '良好':
                            return (
                              <TableTag
                                background="#E2E4FF"
                                color="#2973FF"
                                style={{ marginLeft: 8, padding: '2px 6px' }}
                              >
                                {task_level}
                              </TableTag>
                            )

                          case '较差':
                            return (
                              <TableTag
                                background="#FFEBB4"
                                color="#FFA709"
                                style={{ marginLeft: 8, padding: '2px 6px' }}
                              >
                                {task_level}
                              </TableTag>
                            )

                          case '差':
                            return (
                              <TableTag
                                background="#FFC9C9"
                                color="#FF2929"
                                style={{ marginLeft: 8, padding: '2px 6px' }}
                              >
                                {task_level}
                              </TableTag>
                            )

                          default:
                            return null
                        }
                      })()}
                    </div>
                  )}
                </Checkbox>
                <Typography.Text
                  style={{
                    width: 'calc(230px - 90px)',
                    marginLeft: 8,
                  }}
                  className="group-name"
                  ellipsis={{
                    tooltip: {
                      getPopupContainer: (node: any) =>
                        node.parentNode?.parentNode?.parentNode?.parentNode?.parentNode?.parentNode
                          ?.parentNode?.parentNode?.parentNode || document.body,
                    },
                  }}
                >
                  {name}
                </Typography.Text>
              </div>
              <div className="footer">
                {t('最近评估：')}
                {task_end_time ? (
                  task_end_time
                ) : (
                  <TableTag style={{ padding: '2px 4px' }} background="#D9D9D9" color="#666666">
                    {t('未评估')}
                  </TableTag>
                )}
              </div>
            </div>
            <div className="toolbar">
              <Dropdown overlay={menu}>
                <IconFont
                  style={{
                    fontSize: '18px',
                    color: '#666',
                  }}
                  type="icon-gengduocaozuo"
                />
              </Dropdown>
            </div>
          </GroupItem>
        </div>
      )
    },
    [
      list,
      current,
      isSelected,
      toggle,
      getTaskList,
      setSelectGroup,
      setCurrent,
      navigate,
      editForm,
      t,
    ],
  )

  return (
    <PageContainer>
      {upLoadGroupModal ? (
        <BatchAdd
          selectGroup={selectGroup}
          getEmailList$={getEmailList$}
          cancel={cancel}
          id={selectGroup.id}
        />
      ) : (
        <UserContainer>
          <LeftCard
            title={
              <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                <SignTitle style={{ width: 100 }}>{t('评估目标')}</SignTitle>
                <Button
                  style={{ height: 28, display: 'flex', alignItems: 'center' }}
                  type="primary"
                  onClick={() => {
                    setIsModalVisible(true)
                  }}
                >
                  {t('标签管理')}
                </Button>
              </div>
            }
          >
            <SearchGroup>
              <SearchInputTwo
                inputProps={{
                  placeholder: t('请输入部门名称'),
                  value: searchGroup,
                  onChange: e => {
                    setSearchGroup(e.target.value)
                    searchTask(e.target.value)
                  },
                }}
              />
            </SearchGroup>
            <Modal
              title={<SignTitle show>{t('添加部门')}</SignTitle>}
              visible={modalDetail.addVisible}
              onOk={() => {
                addForm.submit()
              }}
              onCancel={() => {
                addForm.resetFields()
                setModalDetail(defaultModalDetail)
              }}
              centered
            >
              <Form form={addForm} layout={'vertical'} onFinish={handleAddGroup}>
                <Form.Item
                  name="name"
                  rules={[
                    { required: true, message: t('请输入部门名称') },
                    {
                      validator: async (_, newName) => {
                        if (
                          groupList.some((group, index) => index !== 0 && group.name === newName)
                        ) {
                          return Promise.reject(t('存在相同部门名称'))
                        }
                      },
                    },
                    {
                      max: 60,
                      message: t('部门名称最多60字'),
                    },
                    {
                      pattern: /^(?=.*\S).+$/,
                      message: t('部门名称不能全部为空格!'),
                    },
                  ]}
                  label={t('部门名称')}
                >
                  <Input placeholder={t('请输入')} />
                </Form.Item>
              </Form>
            </Modal>
            <Modal
              title={<SignTitle show>{t('编辑部门')}</SignTitle>}
              visible={modalDetail.editVisible}
              onOk={() => {
                editForm.submit()
              }}
              onCancel={() => {
                editForm.resetFields()
                setModalDetail(defaultModalDetail)
              }}
              centered
            >
              <Form form={editForm} layout={'vertical'} onFinish={handleEditGroup}>
                <Form.Item
                  name="name"
                  rules={[
                    { required: true, message: t('请输入部门名称') },
                    // {
                    //   validator: async (_, newName) => {
                    //     if (
                    //       groupList
                    //         ?.filter(item => item.id !== modalDetail.id)
                    //         .some(group => group.name === newName)
                    //     ) {
                    //       return Promise.reject('存在相同部门名称')
                    //     }
                    //   },
                    // },
                    {
                      max: 60,
                      message: t('部门名称最多60字'),
                    },
                    {
                      pattern: /^(?=.*\S).+$/,
                      message: t('部门名称不能全部为空格!'),
                    },
                  ]}
                  label={t('部门名称')}
                >
                  <Input placeholder={t('请输入')} />
                </Form.Item>
              </Form>
            </Modal>
            <DeleteModal
              text={t('此操作将永久删除，是否继续')}
              visible={modalDetail.deleteVisible}
              onOk={handleDeleteGroup}
              onCancel={() => {
                setModalDetail(defaultModalDetail)
              }}
            />

            <HeaderToolbar>
              <div className="checkbox">
                <Checkbox
                  checked={allSelected}
                  onClick={toggleAll}
                  indeterminate={partiallySelected}
                >
                  {t('全选')}
                </Checkbox>
              </div>
              <DeleteButton
                isActive={selected.length > 0}
                onClick={() => {
                  /**去掉未分配部门的id */
                  const excludeItem = list.find((it: any) => it.name === '未分配部门')
                  const filteredSelected = selected.filter(it => it !== excludeItem.id)
                  if (filteredSelected.length > 0) {
                    setModalDetail({ deleteVisible: true, ids: filteredSelected })
                  }
                }}
              >
                <SvgIcon
                  name={selected?.length > 0 ? 'batch_remove' : 'batch_remove_ash'}
                  className="icon-delete"
                />

                <span>{t('批量删除')}</span>
              </DeleteButton>
            </HeaderToolbar>
            <GroupContainer ref={listContainerRef}>
              <div
                onClick={() => {
                  setSelectGroup({
                    id: null,
                    name: groupList[0].name,
                  })
                  setCurrent({
                    id: null,
                    name: groupList[0].name,
                  })
                }}
                className="company-name"
                style={{ background: `${current?.id === null ? '#ebeef7' : ''}` }}
              >
                <IconFont type="icon-gongsi" />
                <Typography.Text style={{ maxWidth: '200px' }} ellipsis={{ tooltip: true }}>
                  {groupList[0]?.name}
                </Typography.Text>
              </div>
              <div className="group-item">
                {list && list.length > 0 ? (
                  <FixedSizeList
                    height={listHeight}
                    itemCount={list.length}
                    itemSize={72}
                    width="100%"
                  >
                    {renderVirtualListItem}
                  </FixedSizeList>
                ) : null}
              </div>
            </GroupContainer>
            <LeftCardFooter>
              <Button
                type={'primary'}
                style={{ width: '100%' }}
                onClick={() => {
                  setModalDetail({ addVisible: true })
                }}
              >
                {t('添加部门')}
              </Button>
            </LeftCardFooter>
          </LeftCard>
          <RightContainer>
            <GroupListContainer>
              <ListContainer>
                {current?.id !== null ? (
                  <div>
                    {taskList?.items ? (
                      <>
                        <RecentlyFold
                          className="content"
                          activeKey={recently}
                          ghost
                          expandIconPosition={'end'}
                          onChange={e => {
                            setRecently(e)
                          }}
                        >
                          <Panel
                            header={
                              <div>
                                <div
                                  style={{
                                    display: 'flex',
                                    justifyContent: 'space-between',
                                  }}
                                >
                                  <div style={{ fontWeight: 600 }}>{t('最近任务')}</div>
                                  <IconFont
                                    type="icon-zhankai1"
                                    style={{
                                      transform: `${
                                        recently.length > 0 ? 'none' : 'rotate(180deg)'
                                      }`,
                                    }}
                                  />
                                </div>
                                <div
                                  style={{
                                    display: recently.length > 0 ? 'none' : 'flex',
                                    width: '70%',
                                  }}
                                >
                                  <div className="task-fold">
                                    <Typography.Text
                                      style={{ width: '126px', height: 21 }}
                                      ellipsis={{ tooltip: true }}
                                    >
                                      {taskList?.items?.[0]?.name || '-'}
                                    </Typography.Text>
                                    <div style={{ display: 'flex' }}>
                                      <p
                                        className={
                                          (taskList?.items?.[0]?.score <= 100 &&
                                            taskList?.items?.[0]?.score >= 80 &&
                                            'score-excellent') ||
                                          (taskList?.items?.[0]?.score < 80 &&
                                            taskList?.items?.[0]?.score >= 60 &&
                                            'score-good ') ||
                                          (taskList?.items?.[0]?.score < 60 &&
                                            taskList?.items?.[0]?.score >= 40 &&
                                            'score-medium') ||
                                          (taskList?.items?.[0]?.score < 40 &&
                                            'score-difference') ||
                                          'score-difference'
                                        }
                                      >
                                        {(taskList?.items?.[0]?.score <= 100 &&
                                          taskList?.items?.[0]?.score >= 80 &&
                                          t('优秀')) ||
                                          (taskList?.items?.[0]?.score < 80 &&
                                            taskList?.items?.[0]?.score >= 60 &&
                                            t('良好')) ||
                                          (taskList?.items?.[0]?.score < 60 &&
                                            taskList?.items?.[0]?.score >= 40 &&
                                            t('较差')) ||
                                          (taskList?.items?.[0]?.score < 40 && t('差')) ||
                                          t('差')}
                                        /{taskList?.items?.[0]?.score || 0}
                                      </p>
                                      <IconFont
                                        type={'icon-jinru'}
                                        style={{ fontSize: 12 }}
                                        onClick={() => {
                                          navigate(
                                            `/validation/awareness/phishing?tab=task&name=detail&id=${taskList?.items?.[0]?.id}`,
                                            {
                                              state: {
                                                type: taskList?.items?.[0]?.email_type,
                                                name: taskList?.items?.[0]?.name,
                                                score: taskList?.items?.[0]?.score || 0,
                                                start_time: taskList?.items?.[0]?.start_time,
                                              },
                                            },
                                          )
                                        }}
                                      />
                                    </div>
                                  </div>
                                  <div className="task-fold">
                                    <Typography.Text
                                      style={{ width: '126px', height: 21 }}
                                      ellipsis={{ tooltip: true }}
                                    >
                                      {taskList?.items?.[1]?.name || '-'}
                                    </Typography.Text>
                                    <div style={{ display: 'flex' }}>
                                      <p
                                        className={
                                          (taskList?.items?.[1]?.score <= 100 &&
                                            taskList?.items?.[1]?.score >= 80 &&
                                            'score-excellent') ||
                                          (taskList?.items?.[1]?.score < 80 &&
                                            taskList?.items?.[1]?.score >= 60 &&
                                            'score-good ') ||
                                          (taskList?.items?.[1]?.score < 60 &&
                                            taskList?.items?.[1]?.score >= 40 &&
                                            'score-medium') ||
                                          (taskList?.items?.[1]?.score < 40 &&
                                            'score-difference') ||
                                          'score-difference'
                                        }
                                      >
                                        {(taskList?.items?.[1]?.score <= 100 &&
                                          taskList?.items?.[1]?.score >= 80 &&
                                          t('优秀')) ||
                                          (taskList?.items?.[1]?.score < 80 &&
                                            taskList?.items?.[1]?.score >= 60 &&
                                            t('良好')) ||
                                          (taskList?.items?.[1]?.score < 60 &&
                                            taskList?.items?.[1]?.score >= 40 &&
                                            t('较差')) ||
                                          (taskList?.items?.[1]?.score < 40 && t('差')) ||
                                          t('差')}
                                        /{taskList?.items?.[1]?.score || '-'}
                                      </p>
                                      <IconFont
                                        type={'icon-jinru'}
                                        style={{ fontSize: 12 }}
                                        onClick={() => {
                                          if (taskList?.items?.[1]?.id) {
                                            navigate(
                                              `/validation/awareness/phishing?tab=task&name=detail&id=${taskList?.items?.[1]?.id}`,
                                              {
                                                state: {
                                                  type: taskList?.items?.[1]?.email_type,
                                                  name: taskList?.items?.[1]?.name,
                                                  score: taskList?.items?.[1]?.score,
                                                  start_time: taskList?.items?.[1]?.start_time,
                                                },
                                              },
                                            )
                                          }
                                        }}
                                      />
                                    </div>
                                  </div>
                                  <div className="task-fold">
                                    <Typography.Text
                                      style={{ width: '126px', height: 21 }}
                                      ellipsis={{ tooltip: true }}
                                    >
                                      {taskList?.items?.[2]?.name || '-'}
                                    </Typography.Text>
                                    <div style={{ display: 'flex' }}>
                                      <p
                                        className={
                                          (taskList?.items?.[2]?.score <= 100 &&
                                            taskList?.items?.[2]?.score >= 80 &&
                                            'score-excellent') ||
                                          (taskList?.items?.[2]?.score < 80 &&
                                            taskList?.items?.[2]?.score >= 60 &&
                                            'score-good ') ||
                                          (taskList?.items?.[2]?.score < 60 &&
                                            taskList?.items?.[2]?.score >= 40 &&
                                            'score-medium') ||
                                          (taskList?.items?.[2]?.score < 40 &&
                                            'score-difference') ||
                                          'score-difference'
                                        }
                                      >
                                        {(taskList?.items?.[2]?.score <= 100 &&
                                          taskList?.items?.[2]?.score >= 80 &&
                                          t('优秀')) ||
                                          (taskList?.items?.[2]?.score < 80 &&
                                            taskList?.items?.[2]?.score >= 60 &&
                                            t('良好')) ||
                                          (taskList?.items?.[2]?.score < 60 &&
                                            taskList?.items?.[2]?.score >= 40 &&
                                            t('较差')) ||
                                          (taskList?.items?.[2]?.score < 40 && t('差')) ||
                                          t('差')}
                                        /{taskList?.items?.[2]?.score || '-'}
                                      </p>
                                      <IconFont
                                        type={'icon-jinru'}
                                        style={{ fontSize: 12 }}
                                        onClick={() => {
                                          if (taskList?.items?.[2]?.id) {
                                            navigate(
                                              `/validation/awareness/phishing?tab=task&name=detail&id=${taskList?.items?.[2]?.id}`,
                                              {
                                                state: {
                                                  type: taskList?.items?.[2]?.email_type,
                                                  name: taskList?.items?.[2]?.name,
                                                  score: taskList?.items?.[2]?.score,
                                                  start_time: taskList?.items?.[2]?.start_time,
                                                },
                                              },
                                            )
                                          }
                                        }}
                                      />
                                    </div>
                                  </div>
                                </div>
                              </div>
                            }
                            key={1}
                            showArrow={false}
                          >
                            <div
                              style={{
                                display: 'flex',
                                alignContent: 'space-between',
                                alignItems: 'center',
                              }}
                            >
                              <div style={{ width: 'calc(50% - 20px)' }}>
                                <div style={{ display: 'flex' }}>
                                  <ReactECharts
                                    style={{
                                      display: 'flex',
                                      justifyContent: 'center',
                                      width: '32%',
                                      height: '.9rem',
                                      marginRight: 20,
                                    }}
                                    option={option({
                                      value: taskList?.items?.[0]?.score,
                                      title:
                                        (taskList?.items?.[0]?.score <= 100 &&
                                          taskList?.items?.[0]?.score >= 80 &&
                                          t('优秀')) ||
                                        (taskList?.items?.[0]?.score < 80 &&
                                          taskList?.items?.[0]?.score >= 60 &&
                                          t('良好')) ||
                                        (taskList?.items?.[0]?.score < 60 &&
                                          taskList?.items?.[0]?.score >= 40 &&
                                          t('较差')) ||
                                        (taskList?.items?.[0]?.score < 40 && t('差')) ||
                                        t('差'),
                                    })}
                                  />

                                  <ReactECharts
                                    style={{
                                      display: 'flex',
                                      justifyContent: 'center',
                                      width: '32%',
                                      height: '.9rem',
                                      marginRight: 20,
                                    }}
                                    option={option({
                                      value: taskList?.items?.[1]?.score,
                                      title:
                                        (taskList?.items?.[1]?.score <= 100 &&
                                          taskList?.items?.[1]?.score >= 80 &&
                                          t('优秀')) ||
                                        (taskList?.items?.[1]?.score < 80 &&
                                          taskList?.items?.[1]?.score >= 60 &&
                                          t('良好')) ||
                                        (taskList?.items?.[1]?.score < 60 &&
                                          taskList?.items?.[1]?.score >= 40 &&
                                          t('较差')) ||
                                        (taskList?.items?.[1]?.score < 40 && t('差')) ||
                                        t('差'),
                                    })}
                                  />

                                  <ReactECharts
                                    style={{
                                      display: 'flex',
                                      justifyContent: 'center',
                                      width: '32%',
                                      height: '.9rem',
                                    }}
                                    option={option({
                                      value: taskList?.items?.[2]?.score,
                                      title:
                                        (taskList?.items?.[2]?.score <= 100 &&
                                          taskList?.items?.[2]?.score >= 80 &&
                                          t('优秀')) ||
                                        (taskList?.items?.[2]?.score < 80 &&
                                          taskList?.items?.[2]?.score >= 60 &&
                                          t('良好')) ||
                                        (taskList?.items?.[2]?.score < 60 &&
                                          taskList?.items?.[2]?.score >= 40 &&
                                          t('较差')) ||
                                        (taskList?.items?.[2]?.score < 40 && t('差')) ||
                                        t('差'),
                                    })}
                                  />
                                </div>
                                <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                                  <div
                                    style={{
                                      marginRight: 10,
                                      display: 'flex',
                                      justifyContent: 'center',
                                      width: '32%',
                                    }}
                                  >
                                    <Tooltip
                                      placement="topLeft"
                                      title={
                                        taskList?.items?.[0]?.name?.length >= 6
                                          ? taskList?.items?.[0]?.name
                                          : ''
                                      }
                                    >
                                      <div
                                        className={
                                          (taskList?.items?.[0]?.score <= 100 &&
                                            taskList?.items?.[0]?.score >= 80 &&
                                            'task-name-excellent') ||
                                          (taskList?.items?.[0]?.score < 80 &&
                                            taskList?.items?.[0]?.score >= 60 &&
                                            'task-name-good') ||
                                          (taskList?.items?.[0]?.score < 60 &&
                                            taskList?.items?.[0]?.score >= 40 &&
                                            'task-name-medium') ||
                                          (taskList?.items?.[0]?.score < 40 &&
                                            'task-name-seriousness') ||
                                          'task-name-seriousness'
                                        }
                                      >
                                        <div
                                          className={
                                            (taskList?.items?.[0]?.score <= 100 &&
                                              taskList?.items?.[0]?.score >= 80 &&
                                              'excellent-text') ||
                                            (taskList?.items?.[0]?.score < 80 &&
                                              taskList?.items?.[0]?.score >= 60 &&
                                              'good-text') ||
                                            (taskList?.items?.[0]?.score < 60 &&
                                              taskList?.items?.[0]?.score >= 40 &&
                                              'medium-text') ||
                                            (taskList?.items?.[0]?.score < 40 &&
                                              'seriousness-text') ||
                                            'seriousness-text'
                                          }
                                        >
                                          {taskList?.items?.[0]?.name || '-'}
                                        </div>
                                        <IconFont
                                          type={'icon-jinru'}
                                          style={{ fontSize: 12, marginLeft: 14 }}
                                          onClick={() => {
                                            if (taskList?.items?.[0]?.name) {
                                              navigate(
                                                `/validation/awareness/phishing?tab=task&name=detail&id=${taskList?.items?.[0]?.id}`,
                                                {
                                                  state: {
                                                    type: taskList?.items?.[0]?.email_type,
                                                    name: taskList?.items?.[0]?.name,
                                                    score: taskList?.items?.[0]?.score,
                                                    start_time: taskList?.items?.[0]?.start_time,
                                                  },
                                                },
                                              )
                                            }
                                          }}
                                        />
                                      </div>
                                    </Tooltip>
                                  </div>
                                  <div
                                    style={{
                                      marginRight: 10,
                                      display: 'flex',
                                      justifyContent: 'center',
                                      width: '32%',
                                    }}
                                  >
                                    <Tooltip
                                      placement="topLeft"
                                      title={
                                        taskList?.items?.[1]?.name?.length >= 6
                                          ? taskList?.items?.[1]?.name
                                          : ''
                                      }
                                    >
                                      <div
                                        className={
                                          (taskList?.items?.[1]?.score <= 100 &&
                                            taskList?.items?.[1]?.score >= 80 &&
                                            'task-name-excellent') ||
                                          (taskList?.items?.[1]?.score < 80 &&
                                            taskList?.items?.[1]?.score >= 60 &&
                                            'task-name-good') ||
                                          (taskList?.items?.[1]?.score < 60 &&
                                            taskList?.items?.[1]?.score >= 40 &&
                                            'task-name-medium') ||
                                          (taskList?.items?.[1]?.score < 40 &&
                                            'task-name-seriousness') ||
                                          'task-name-seriousness'
                                        }
                                      >
                                        <div
                                          className={
                                            (taskList?.items?.[1]?.score <= 100 &&
                                              taskList?.items?.[1]?.score >= 80 &&
                                              'excellent-text') ||
                                            (taskList?.items?.[1]?.score < 80 &&
                                              taskList?.items?.[1]?.score >= 60 &&
                                              'good-text') ||
                                            (taskList?.items?.[1]?.score < 60 &&
                                              taskList?.items?.[1]?.score >= 40 &&
                                              'medium-text') ||
                                            (taskList?.items?.[1]?.score < 40 &&
                                              'seriousness-text') ||
                                            'seriousness-text'
                                          }
                                        >
                                          {taskList?.items?.[1]?.name || '-'}
                                        </div>
                                        <IconFont
                                          type={'icon-jinru'}
                                          style={{ fontSize: 12, marginLeft: 14 }}
                                          onClick={() => {
                                            if (taskList?.items?.[1]?.name) {
                                              navigate(
                                                `/validation/awareness/phishing?tab=task&name=detail&id=${taskList?.items?.[1]?.id}`,
                                                {
                                                  state: {
                                                    type: taskList?.items?.[1]?.email_type,
                                                    name: taskList?.items?.[1]?.name,
                                                    score: taskList?.items?.[1]?.score,
                                                    start_time: taskList?.items?.[1]?.start_time,
                                                  },
                                                },
                                              )
                                            }
                                          }}
                                        />
                                      </div>
                                    </Tooltip>
                                  </div>
                                  <div
                                    style={{
                                      display: 'flex',
                                      justifyContent: 'center',
                                      width: '32%',
                                    }}
                                  >
                                    <Tooltip
                                      placement="topLeft"
                                      title={
                                        taskList?.items?.[2]?.name?.length >= 6
                                          ? taskList?.items?.[2]?.name
                                          : ''
                                      }
                                    >
                                      <div
                                        className={
                                          (taskList?.items?.[2]?.score <= 100 &&
                                            taskList?.items?.[2]?.score >= 80 &&
                                            'task-name-excellent') ||
                                          (taskList?.items?.[2]?.score < 80 &&
                                            taskList?.items?.[2]?.score >= 60 &&
                                            'task-name-good') ||
                                          (taskList?.items?.[2]?.score < 60 &&
                                            taskList?.items?.[2]?.score >= 40 &&
                                            'task-name-medium') ||
                                          (taskList?.items?.[2]?.score < 40 &&
                                            'task-name-seriousness') ||
                                          'task-name-seriousness'
                                        }
                                      >
                                        <div
                                          className={
                                            (taskList?.items?.[2]?.score <= 100 &&
                                              taskList?.items?.[2]?.score >= 80 &&
                                              'excellent-text') ||
                                            (taskList?.items?.[2]?.score < 80 &&
                                              taskList?.items?.[2]?.score >= 60 &&
                                              'good-text') ||
                                            (taskList?.items?.[2]?.score < 60 &&
                                              taskList?.items?.[2]?.score >= 40 &&
                                              'medium-text') ||
                                            (taskList?.items?.[2]?.score < 40 &&
                                              'seriousness-text') ||
                                            'seriousness-text'
                                          }
                                        >
                                          {taskList?.items?.[2]?.name || '-'}
                                        </div>
                                        <IconFont
                                          type={'icon-jinru'}
                                          style={{ fontSize: 12, marginLeft: 14 }}
                                          onClick={() => {
                                            if (taskList?.items?.[2]?.name) {
                                              navigate(
                                                `/validation/awareness/phishing?tab=task&name=detail&id=${taskList?.items?.[2]?.id}`,
                                                {
                                                  state: {
                                                    type: taskList?.items?.[2]?.email_type,
                                                    name: taskList?.items?.[2]?.name,
                                                    score: taskList?.items?.[2]?.score,
                                                    start_time: taskList?.items?.[2]?.start_time,
                                                  },
                                                },
                                              )
                                            }
                                          }}
                                        />
                                      </div>
                                    </Tooltip>
                                  </div>
                                </div>
                              </div>
                              <div
                                style={{
                                  height: '.8rem',
                                  width: 1,
                                  marginLeft: 20,
                                }}
                              />

                              <div
                                style={{
                                  width: '50%',
                                  height: '1rem',
                                  marginLeft: 10,
                                  marginTop: 10,
                                  marginBottom: 10,
                                  padding: '12px 7px',
                                  borderRadius: 8,
                                  background: '#F7F8F9',
                                }}
                              >
                                <Scrollbars>
                                  {taskList?.items?.map(item => (
                                    <div className="task" key={item.id}>
                                      <div className="task-left">
                                        {item?.email_type === '恶意附件' && (
                                          <div className="accessory">{t('恶意附件')}</div>
                                        )}
                                        {item?.email_type === '钓鱼链接' && (
                                          <div className="link">{t('钓鱼链接')}</div>
                                        )}
                                        <Typography.Text
                                          ellipsis={{
                                            tooltip: { getPopupContainer: () => document.body },
                                          }}
                                          className="task-text"
                                        >
                                          {item?.name}
                                        </Typography.Text>
                                      </div>
                                      <div className="task-right">
                                        {100 >= item.score && item.score >= 80 && (
                                          <p className="task-excellent">
                                            {t('优秀/')}
                                            {item.score}
                                          </p>
                                        )}
                                        {80 > item.score && item.score >= 60 && (
                                          <p className="task-good">
                                            {t('良好/')}
                                            {item.score}
                                          </p>
                                        )}
                                        {60 > item.score && item.score >= 40 && (
                                          <p className="task-medium ">
                                            {t('较差/')}
                                            {item.score}
                                          </p>
                                        )}
                                        {item.score < 40 && (
                                          <p className="task-range">
                                            {t('差/')}
                                            {item.score}
                                          </p>
                                        )}
                                        {!item.score && <p className="task-range">{t('差/0')}</p>}
                                        <p className="task-time">{item?.end_time}</p>
                                        <IconFont
                                          type={'icon-jinru'}
                                          style={{ fontSize: 12 }}
                                          onClick={() => {
                                            navigate(
                                              `/validation/awareness/phishing?tab=task&name=detail&id=${item.id}`,
                                              {
                                                state: {
                                                  type: item.email_type,
                                                  name: item.name,
                                                  score: item.score,
                                                  start_time: item?.start_time,
                                                },
                                              },
                                            )
                                          }}
                                        />
                                      </div>
                                    </div>
                                  ))}
                                </Scrollbars>
                              </div>
                            </div>
                          </Panel>
                        </RecentlyFold>
                        <>
                          <img
                            src={Overview}
                            alt=""
                            style={{ width: '100%', height: 2, marginBottom: 16 }}
                          />

                          <TaskName
                            id={taskList?.items?.[0]?.id}
                            type={taskList?.items?.[0]?.email_type}
                            score={taskList?.items?.[0]?.score}
                            start_time={taskList?.items?.[0]?.end_time}
                            name={taskList?.items?.[0]?.name}
                          />
                        </>
                      </>
                    ) : (
                      <>
                        <div style={{ fontWeight: 600 }}>{t('最近任务')}</div>
                        <Empty image={EmptyImg} />
                      </>
                    )}
                  </div>
                ) : (
                  <div>
                    <CompanyScore name={groupList.length > 0 ? groupList[0]?.name : ''} />
                  </div>
                )}
              </ListContainer>
              <List
                handleBatchAdd={handleBatchAdd}
                getGroupList={getGroupList}
                selectGroup={selectGroup}
                getEmailList$={getEmailList$}
                groupList={groupList || []}
                visible={visible}
                tagList={TagListData}
                key={selectGroup?.id}
                getTagList={getTagList}
              />
            </GroupListContainer>
          </RightContainer>
        </UserContainer>
      )}
      <LabelManagement
        visible={isModalVisible}
        close={isModalVisibleClose}
        getTagList={TagListData}
        tagList={getTagList}
      />
    </PageContainer>
  )
}
export default User

const UserContainer = styled.div`
  width: 100%;
  min-height: 100%;
  display: flex;
`

const LeftCard = styled(SmallPaddingCard)`
  width: 320px;
  margin-right: 16px;
  border-radius: 8px;
  box-shadow: 0px 4px 8px 0px rgba(95, 103, 129, 0.06);

  .ant-card-body {
    display: flex;
    flex-direction: column;
    padding-top: 8px;
    /* height:100% */
    .ant-checkbox + span {
      padding: 0;
    }
  }
  .ant-card-head-title {
    padding-bottom: 14px;
    border-bottom: 1px solid #eaedf1;
  }
`

const GroupListContainer = styled(Scrollbars)`
  flex-grow: 1;
  height: 0;
`

const LeftCardFooter = styled.div`
  height: 32px;
  display: flex;
  justify-content: space-between;
  margin-top: 10px;
`
const GroupContainer = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  .ant-dropdown-menu {
    padding: 1px;
  }
  .ant-dropdown-menu-item {
    margin: 1px;
    padding: 0;
    border-radius: 4px;
  }
  .group-menu-item {
    padding: 5px 2px;
    margin-right: 12px;
  }
  .company-name {
    width: 100%;
    height: 72px;
    border-radius: 6px;
    font-size: 14px;
    font-family: SourceHanSansCN-Normal, SourceHanSansCN;
    font-weight: 400;
    color: #333333;
    line-height: 21px;
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 6px;
    cursor: pointer;
    &:hover {
      background: #ebeef7;
    }
  }
  .group-item {
    flex-grow: 1;
    height: 0px;
    border-top: 1px solid #eaedf1;
    margin-top: 12px;
  }
`
interface ItemProps {
  isActive: boolean
}
const GroupItem = styled.div<ItemProps>`
  width: 100%;
  height: 60px;
  border-radius: 6px;
  margin-top: 12px;
  padding-left: 10px;
  padding-right: 10px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 8px;
  cursor: pointer;
  background-color: ${props => (props.isActive ? '#e7e9f3' : '')};
  &:hover {
    background-color: #e7e9f3;
  }
  .detail {
    display: flex;
    flex-direction: column;
    gap: 12px;
    .header {
      .group-tag {
        /* margin-right: 4px; */
      }
      .group-name {
        font-size: 14px;
        font-family: SourceHanSansCN-Normal, SourceHanSansCN;
        font-weight: 400;
        color: #333333;
        line-height: 21px;
      }
    }
    .footer {
      font-size: 12px;
      font-family: SourceHanSansCN-Normal, SourceHanSansCN;
      font-weight: 400;
      color: #666666;
      line-height: 18px;
    }
  }
  .toolbar {
    .group-menu {
      .ant-dropdown-menu-item:hover {
        background-color: #e7e9f3;
      }
    }
  }
`

const RightContainer = styled.div`
  width: 0;
  flex-grow: 1;
  display: flex;
  flex-direction: column;
  /* background-color: red; */
  .task-name-excellent {
    width: 0.52rem;
    padding: 5px 8px;
    display: flex;
    justify-content: space-between;
    background: rgba(127, 182, 99, 0.1);
    border-radius: 4px;
    border: 1px solid #a3cb8f;
    cursor: pointer;
    .excellent-text {
      color: #7fb563;
      word-wrap: break-word; /*强制换行*/
      overflow: hidden; /*超出隐藏*/
      text-overflow: ellipsis; /*隐藏后添加省略号*/
      white-space: nowrap; /*强制不换行*/
    }
  }
  .text-fold {
    word-wrap: break-word; /*强制换行*/
    overflow: hidden; /*超出隐藏*/
    text-overflow: ellipsis; /*隐藏后添加省略号*/
    white-space: nowrap; /*强制不换行*/
  }
  .task-name-good {
    padding: 5px 8px;
    width: 0.52rem;
    display: flex;
    justify-content: space-between;
    align-items: center;
    background: RGBA(115, 157, 255, 0.1);
    border-radius: 4px;
    border: 1px solid #8fb1ff;
    .good-text {
      color: #739dff;
      word-wrap: break-word; /*强制换行*/
      overflow: hidden; /*超出隐藏*/
      text-overflow: ellipsis; /*隐藏后添加省略号*/
      white-space: nowrap; /*强制不换行*/
    }
  }
  .task-name-medium {
    padding: 5px 8px;
    width: 0.52rem;
    display: flex;
    justify-content: space-between;
    align-items: center;
    background: rgba(255, 176, 53, 0.1);
    border-radius: 4px;
    border: 1px solid #ffd257;
    .medium-text {
      color: #ffb035;
      word-wrap: break-word; /*强制换行*/
      overflow: hidden; /*超出隐藏*/
      text-overflow: ellipsis; /*隐藏后添加省略号*/
      white-space: nowrap; /*强制不换行*/
    }
  }
  .task-name-seriousness {
    padding: 5px 8px;
    width: 0.52rem;
    display: flex;
    justify-content: space-between;
    align-items: center;
    background: rgba(255, 81, 81, 0.1);
    border-radius: 4px;
    border: 1px solid #ed8f92;
    .seriousness-text {
      color: #ff5151;
      word-wrap: break-word; /*强制换行*/
      overflow: hidden; /*超出隐藏*/
      text-overflow: ellipsis; /*隐藏后添加省略号*/
      white-space: nowrap; /*强制不换行*/
    }
  }
`

const HeaderToolbar = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 12px;
  .checkbox {
    margin-left: 10px;
  }
`
interface ItemProps {
  isActive: boolean
}
const DeleteButton = styled.div<ItemProps>`
  width: 76px;
  height: 24px;
  line-height: 24px;
  font-size: 12px;
  border-radius: 4px;
  display: flex;
  align-items: center;
  cursor: ${props => (props.isActive ? 'pointer' : 'no-drop')};
  color: ${props => (props.isActive ? '#333' : '#999')};
  justify-content: center;
  transition: 0.3s;
  &:hover {
    background-color: ${props => (props.isActive ? 'rgba(245, 63, 63, 0.1)' : '')};
    .icon-delete {
      width: 12px;
      stroke: ${props => (props.isActive ? '#f53f3f' : '')};
    }
  }
  .icon-delete {
    width: 12px;
    transition: 0.3s;
    height: 12px;
    margin-right: 3px;
  }
`

const SearchGroup = styled.div`
  margin-top: 8px;
  margin-bottom: 16px;
`
const ListContainer = styled(Card)`
  margin-bottom: 16px;
  border-radius: 8px;

  .ant-collapse-header {
    padding: 0 !important;
  }
`
const RecentlyFold = styled(Collapse)`
  background: #fff !important;
  .ant-collapse-header {
    width: 100%;
    padding-right: 20px !important;
    padding-bottom: 0px !important;
  }
  .ant-collapse-header-text {
    width: 100%;
  }
  .ant-collapse-content-box {
    padding-top: 0 !important;
  }
  .task-fold {
    margin-top: 15px;
    width: 32%;
    padding: 9px 12px 9px 12px;
    display: flex;
    background-color: #f7f8f9;
    height: 32px;
    justify-content: space-between;
    border-radius: 6px;
    margin-bottom: 24px;
    margin-right: 10px;
  }
  .score-excellent {
    margin-right: 10px;
    color: #5bc825;
    font-size: 12px;
  }
  .score-good {
    margin-right: 10px;
    color: #2973ff;
    font-size: 12px;
  }
  .score-medium {
    margin-right: 10px;
    font-size: 12px;
    color: #ffa709;
  }
  .score-difference {
    margin-right: 10px;
    font-size: 12px;
    color: #ff5151;
  }
  .task {
    height: 32px;
    background: #ffffff;
    border-radius: 6px;
    display: flex;
    align-items: center;
    padding: 0 8px 0 13px;
    margin-bottom: 4px;
    justify-content: space-between;
    transition: all 0.3s;
    cursor: pointer;
    &:hover {
      background: #e7e9f3;
    }
  }
  .accessory {
    padding: 4px 8px;
    font-size: 12px;
    color: #d0011c;
    background: #f5d9da;
    border-radius: 4px;
  }
  .link {
    padding: 4px 8px;
    font-size: 12px;
    color: #645aff;
    background: #ddd9ff;
    border-radius: 4px;
  }
  .task-text {
    margin: 0;
    margin-left: 10px;
    width: 40%;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }
  .task-left {
    display: flex;
    align-items: center;
    width: 50%;
  }
  .task-right {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    width: 45%;
  }
  .task-excellent {
    color: #5bc825;
    margin: 0;
    height: auto;
    white-space: nowrap;
    text-align: left;
    width: 50px;
  }
  .task-good {
    color: #2973ff;
    margin: 0;
    white-space: nowrap;
    text-align: left;
    width: 50px;
  }
  .task-medium {
    color: #ffa709;
    margin: 0;
    white-space: nowrap;
    text-align: left;
    width: 50px;
  }
  .task-range {
    color: #ff2929;
    margin: 0;
    white-space: nowrap;
    text-align: left;
    width: 50px;
  }
  .task-time {
    margin: 0 10px;
    color: #666666;
  }
`
